/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IPasswordResetVerificationLoadingIcon {
    className: string;
}

const PasswordResetVerificationLoadingIcon: React.FC<IPasswordResetVerificationLoadingIcon> = ({ className }) => (
    <div className={`${className}__loading-icon`} />
);

export default PasswordResetVerificationLoadingIcon;
